import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  selectedCountText: {
    color: theme.palette.text.secondary,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  sectionTitle: {
    fontWeight: 600,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  chipSelected: {
    lineHeight: '1.5rem',
    borderRadius: '10px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: 'fit-content',
    padding: '4px',
  },
  chipUnselected: {
    lineHeight: '1.5rem',
    borderRadius: '10px',
    backgroundColor: theme.palette.contentBackground.grey,
    color: theme.palette.font.primary,
    width: 'fit-content',
    padding: '4px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      '& > button': {
        width: '100%',
      },
    },
  },
}));
